export default __webpack_public_path__ + "static/media/pecheurs.aa4e797e.jpg";